import useScrollLock from "@repo/hooks/utils/useScrollLock";
import React from "react";

interface IProps {
  onClick?: (e: React.MouseEvent) => void;
  children?: React.ReactNode;
}

function Dim({ onClick, children }: IProps) {
  useScrollLock();
  return (
    <div
      className="fixed left-0 top-0 z-30 h-screen w-full bg-black/10 backdrop-blur-xs"
      onClick={(e: React.MouseEvent) => {
        e.preventDefault();
        onClick?.(e);
      }}
      role="presentation"
    >
      {children}
    </div>
  );
}

export default Dim;
